<template>
  <div class="section-title-wrapper">
    <h2 :class="['section-title', { 'xl': xl }]" v-html="text" :id="id"></h2>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: ['text', 'xl', 'id']
}
</script>
